<template>
  <v-app>
    <v-navigation-drawer
      v-if="hideNavigation"
      v-model="drawer"
      app
      color="#100F0F"
      expand-on-hover
    >
      <v-divider></v-divider>

      <v-list nav dark>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          :to="item.link"
          :disabled="disableNavigation || restaurantId === 'null'"
        >
          <v-list-item-icon>
            <v-icon :disabled="disableNavigation || restaurantId === 'null'">{{
              item.icon
            }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <v-list dark>
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-earth</v-icon>
            </v-list-item-icon>

            <v-list-item-content class="py-0">
              <!-- <v-select
                dark
                :items="['Slovak', 'English']"
                single-line
                filled
                rounded
                dense
                hide-details
              ></v-select> -->
              <v-chip-group
                mandatory
                column
                v-model="$i18n.locale"
                @change="changeDefaultLanguage($i18n.locale)"
              >
                <v-chip filter outlined value="sk">SK</v-chip>
                <v-chip filter outlined value="cs">CS</v-chip>
                <v-chip filter outlined value="en">EN</v-chip>
              </v-chip-group>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link @click="logout">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ $t("logout") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>

    <v-app-bar v-if="hideNavigation" app color="white" elevate-on-scroll>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>
        <v-tooltip v-if="$route.name !== 'create'" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              x-small
              :color="isOpenColor"
              style="margin-right: 8px"
              v-bind="attrs"
              v-on="on"
            >
              mdi-checkbox-blank-circle
            </v-icon>
          </template>
          <span v-if="isOpen === null">{{ $t("noData") }}</span>
          <span v-else>{{
            isOpen
              ? $t("acceptingNewOrders")
              : allowPreorderingWhenClosed
              ? $t("acceptingNewPreorders")
              : $t("notAcceptingNewOrders")
          }}</span>
          <!-- <span v-else>{{
            isOpen ? $t("acceptingNewOrders") : $t("notAcceptingNewOrders")
          }}</span> -->
        </v-tooltip>
        <b v-if="this.$router.currentRoute.name === 'dashboard'">{{
          $t("dashboard")
        }}</b>
        <b v-if="this.$router.currentRoute.name === 'orders'">{{
          $t("orders")
        }}</b>
        <b v-if="this.$router.currentRoute.name === 'menu'">{{
          $t("dailyMenu")
        }}</b>
        <b v-if="this.$router.currentRoute.name === 'dishes'">{{
          $t("dishes")
        }}</b>
        <b v-if="this.$router.currentRoute.name === 'options'">{{
          $t("options")
        }}</b>
        <b v-if="this.$router.currentRoute.name === 'zones'">{{
          $t("deliveryZones")
        }}</b>
        <b v-if="this.$router.currentRoute.name === 'customers'">{{
          $t("customers")
        }}</b>
        <b v-if="this.$router.currentRoute.name === 'billing'">{{
          $t("billing")
        }}</b>
        <b v-if="this.$router.currentRoute.name === 'settings'">{{
          $t("settings")
        }}</b>
        <b v-if="this.$router.currentRoute.name === 'widget'">{{
          $t("widget")
        }}</b>
        <b v-if="this.$router.currentRoute.name === 'qrcodes'">{{
          $t("qrcodes")
        }}</b>
        <b v-if="this.$router.currentRoute.name === 'create'">{{
          $t("createNewRestaurant")
        }}</b>
      </v-toolbar-title>
      <v-col
        v-if="
          !$vuetify.breakpoint.xs &&
          (this.$router.currentRoute.name === 'orders' ||
            this.$router.currentRoute.name === 'customers')
        "
        cols="2"
      >
        <v-text-field
          v-model="searchValue"
          :label="
            $router.currentRoute.name === 'orders'
              ? $t('searchInOrders')
              : $t('searchInCustomers')
          "
          filled
          rounded
          dense
          hide-details
          single-line
        ></v-text-field>
      </v-col>

      <v-spacer />
      <v-spacer />
      <v-col
        cols="6"
        sm="3"
        md="2"
        v-if="!disableNavigation && $route.name !== 'create'"
      >
        <v-select
          :key="restaurantId"
          v-model="restaurantId"
          item-text="name"
          item-value="restaurantId"
          :items="access"
          @change="getInitialInfo"
          single-line
          filled
          rounded
          dense
          hide-details
        ></v-select>
      </v-col>
      <v-btn
        v-if="
          !$vuetify.breakpoint.xs &&
          !disableNavigation &&
          $route.name !== 'create'
        "
        icon
        link
        to="/create"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <span v-if="!$vuetify.breakpoint.xs" class="ml-3">{{
        $t("madeWithLoveBy")
      }}</span>
      <v-img
        v-if="!$vuetify.breakpoint.xs"
        class="ml-3"
        max-width="75px"
        max-height="50px"
        src="./assets/piknik-logo-black.png"
        alt="Piknik"
      />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            color="primary"
            :class="$vuetify.breakpoint.xs ? 'ml-0' : 'ml-3'"
            dark
            v-bind="attrs"
            v-on="on"
          >
            mdi-help-circle
          </v-icon>
        </template>
        <span>{{ $t("getHelpToolip") }}</span>
      </v-tooltip>
    </v-app-bar>

    <v-content class="white">
      <v-container fluid class="pt-0">
        <router-view
          :key="restaurantId"
          :searchValue="searchValue"
          @on-open-status-change="isOpen = $event"
          @on-allow-preordering-when-closed-change="
            allowPreorderingWhenClosed = $event
          "
          @on-restaurant-remaining-credit-change="
            remainingRestaurantCredit = $event
          "
          @search-value-change="searchValue = $event"
        ></router-view>
      </v-container>
    </v-content>

    <v-snackbar
      v-model="insufficientRestaurantCredit"
      color="error"
      :timeout="0"
    >
      {{ $t("insufficientRestaurantCredit") }}
      <v-btn text small rounded @click="$router.push('/billing')">{{
        $t("topUp")
      }}</v-btn>
    </v-snackbar>
    <v-snackbar v-model="insufficientPermissionsSnackbar" color="error">
      {{ $t("youDoNotHaveSufficientPermissions") }}
      <v-btn text small rounded @click="insufficientPermissionsSnackbar = false"
        >OK</v-btn
      >
    </v-snackbar>
  </v-app>
</template>

<script>
import restaurantService from "./services/restaurant.service";

export default {
  data() {
    return {
      get access() {
        try {
          return JSON.parse(localStorage.access);
        } catch (e) {
          return null;
        }
      },
      get restaurantId() {
        return localStorage.restaurantId;
      },
      set restaurantId(newRestaurantId) {
        return (localStorage.restaurantId = newRestaurantId);
      },
      drawer: null,
      items: [],
      right: null,
      isOpen: null,
      allowPreorderingWhenClosed: null,
      remainingRestaurantCredit: 1,
      searchValue: "",
      insufficientPermissionsSnackbar: false,
    };
  },
  created() {
    this.$http.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response.status == 403)
          this.insufficientPermissionsSnackbar = true;
        return Promise.reject(error);
      }
    );
  },
  mounted() {
    if (localStorage.access) {
      this.access = JSON.parse(localStorage.access);
      if (this.disableNavigation) this.$router.push("/create");
      if (localStorage.token) this.getInitialInfo();
    }
    if (localStorage.defaultLanguage) {
      this.$i18n.locale = localStorage.defaultLanguage;
    }
    this.items = [
      {
        title: this.$t("dashboard"),
        icon: "mdi-chart-box",
        link: "/dashboard",
      },
      { title: this.$t("orders"), icon: "mdi-file", link: "/orders" },
      { title: this.$t("dailyMenu"), icon: "mdi-calendar", link: "/menu" },
      { title: this.$t("dishes"), icon: "mdi-book-open", link: "/dishes" },
      {
        title: this.$t("options"),
        icon: "mdi-order-bool-ascending-variant",
        link: "/options",
      },
      {
        title: this.$t("deliveryZones"),
        icon: "mdi-truck-delivery",
        link: "/zones",
      },
      {
        title: this.$t("customers"),
        icon: "mdi-account-heart",
        link: "/customers",
      },
      {
        title: this.$t("billing"),
        icon: "mdi-credit-card",
        link: "/billing",
      },
      { title: this.$t("settings"), icon: "mdi-cog", link: "/settings" },
      { title: this.$t("widget"), icon: "mdi-code-tags", link: "/widget" },
    ];
  },
  watch: {
    restaurantId(newRestaurantId) {
      localStorage.restaurantId = newRestaurantId;
    },
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
    hideNavigation: function () {
      if (this.$route.path === "/login" || this.$route.path === "/register")
        return false;
      return true;
    },
    disableNavigation: function () {
      try {
        return (
          (this.restaurantId === "null" || this.access.length === 0) &&
          [
            "dashboard",
            "orders",
            "menu",
            "dishes",
            "options",
            "zones",
            "customers",
            "billing",
            "settings",
            "widget",
            "qrcodes",
            "create",
          ].includes(this.$route.name)
        );
      } catch (error) {
        return false;
      }
    },
    isOpenColor: function () {
      if (this.isOpen === true) return "success";
      else if (this.allowPreorderingWhenClosed) return "#ff9f1a";
      else if (this.isOpen === false) return "error";
      else return "gray";
    },
    insufficientRestaurantCredit: function () {
      return this.remainingRestaurantCredit <= 0;
    },
  },
  methods: {
    logout: function () {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },
    getInitialInfo: async function () {
      const info = await restaurantService.getRestaurant(
        localStorage.restaurantId,
        "isOpen,allowPreorderingWhenClosed,balance,currency"
      );
      this.isOpen = info.isOpen;
      this.allowPreorderingWhenClosed = info.allowPreorderingWhenClosed;
      this.remainingRestaurantCredit = info.balance;
      switch (info.currency) {
        case "EUR":
          localStorage.currencySymbol = "€";
          break;
        case "CZK":
          localStorage.currencySymbol = "Kč";
          break;
      }
    },
    changeDefaultLanguage: function (language) {
      localStorage.defaultLanguage = language;
      this.items = [
        {
          title: this.$t("dashboard"),
          icon: "mdi-chart-box",
          link: "/dashboard",
        },
        { title: this.$t("orders"), icon: "mdi-file", link: "/orders" },
        { title: this.$t("dailyMenu"), icon: "mdi-calendar", link: "/menu" },
        { title: this.$t("dishes"), icon: "mdi-book-open", link: "/dishes" },
        {
          title: this.$t("options"),
          icon: "mdi-order-bool-ascending-variant",
          link: "/options",
        },
        {
          title: this.$t("deliveryZones"),
          icon: "mdi-truck-delivery",
          link: "/zones",
        },
        {
          title: this.$t("customers"),
          icon: "mdi-account-heart",
          link: "/customers",
        },
        {
          title: this.$t("billing"),
          icon: "mdi-credit-card",
          link: "/billing",
        },
        { title: this.$t("settings"), icon: "mdi-cog", link: "/settings" },
        { title: this.$t("widget"), icon: "mdi-code-tags", link: "/widget" },
      ];
    },
  },
};
</script>

<style>
.v-navigation-drawer__border {
  display: none;
}

.theme--light.v-application {
  background: #ffffff;
}

.v-btn--round:not(.v-btn--fab) .v-btn__content .v-icon {
  color: #100f0f !important;
}
</style>